import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ReactTost from "../../ReactTost";

import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import BtnLoader from "../../BtnLoader";

const ChatBotInterface = (props) => {
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [bubbleName, setBubbleName] = useState("");
  const [isFirst, setIsFirst] = useState(true);
  const [color, setColor] = useState("#808080");
  const [headerColor, setHeaderColor] = useState("#416cbe");
  const [displayName, setDisplayName] = useState();
  const [chatBotImage, setChatBotImage] = useState();
  const [initialMsg, setInitialMsg] = useState();
  const [suggestedMsg, setSuggestedMsg] = useState();
  const [btnAlign, setBtnAlign] = useState();
  const [suggestedQuestion, setSuggestedQuestion] = useState([]);
  const [messageType, setMessageType] = useState();
  // const [name, setName] = useState();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const { bot } = useParams();
  const { id } = useParams();
  const { t } = useTranslation();
  const [botId, setBotId] = useState(0);
  const [companyLogo, setCompanyLogo] = useState();
  const [chatInstructionText, setChatInstructionText] = useState();

  function resetHandler() {
    setInitialMsg(t("Hey, How can i help you?"));
  }

  function changeBotImage(e) {
    const reader = new FileReader();
    reader.onloadend = () => {
      setChatBotImage(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  }

  function changeCompanyLogo(e) {
    const reader = new FileReader();
    reader.onloadend = () => {
      setCompanyLogo(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  }

  function updateBot(e) {
    e.preventDefault();
    let chatInterface = {
      bubbleName,
      initialMsg,
      suggestedMsg,
      chatInstructionText,
      displayName,
      color,
      headerColor,
      btnAlign,
      messageType,
    };

    if (chatBotImage) {
      chatInterface.file = chatBotImage;
    }

    if(companyLogo) {
      chatInterface.headerFile = companyLogo;
    }  

    setLoading(true);
    axios
      .patch(
        `${API_URL}/${API_VERSION}/bot/${bot}`,
        {
          chatInterface,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        setType("Success");
        setMessage(t("Chat interface updated successfully"));
        showAlert(true);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (props.botData.length !== 0 && setIsFirst) {
      setBotId(props.botData.id);
      setIsFirst(false);
      if (props.botData.chatInterface) {
        setBtnAlign(props.botData.chatInterface.btnAlign);
        setColor(props.botData.chatInterface.color);
        setHeaderColor(props.botData.chatInterface.headerColor);
        setInitialMsg(props.botData.chatInterface.initialMsg);
        setDisplayName(props.botData.name);
        setMessageType(props.botData.chatInterface.messageType);
        setBubbleName(props.botData.chatInterface.bubbleName);
        setChatInstructionText(props.botData.chatInterface.chatInstructionText);

        if (props.botData.chatInterface.suggestedMsg) {
          setSuggestedQuestion(
            props.botData.chatInterface.suggestedMsg.split("\n")
          );
        }
        setSuggestedMsg(props.botData.chatInterface.suggestedMsg);

        if (props.botData.chatInterface.logoName) {
          setChatBotImage(props.botData.chatInterface.logoName);
        }
      }
    }
  }, [props.botData, isFirst]);

  // useEffect(() => {
  //   axios
  //     .get(`${API_URL}/${API_VERSION}/bot/${bot}`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       const initial = response.data.chatInterface.initialMsg;
  //       setInitialMsg(initial);
  //       const suggestedMsg = response.data.chatInterface.suggestedMsg;
  //       setSuggestedMsg(suggestedMsg);
  //       const name = response.data.chatInterface.name;
  //       setBubbleName(response.data.chatInterface.bubbleName);
  //       setDisplayName(response.data.name);
  //       setColor(response.data.chatInterface.color);
  //       setHeaderColor(response.data.chatInterface.headerColor);
  //       setMessageType(response.data.chatInterface.messageType);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, [API_URL, API_VERSION]);


  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      <section className="settings">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7} className="mb-4">
              <div className="settings_wrap">
                <h3>{t("Chat Interface")}</h3>
                <small className="text-secondary d-block pb-3">
                  {t("applies when embedded on a website")}
                </small>
                <form action="">
                  <div className="form-group">
                    <label className="form-label">
                      {t("Bubble Text")}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="bubbleName"
                      id="name"
                      value={bubbleName}
                      onChange={(event) => {
                        setBubbleName(event.target.value);
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <label className="form-label mb-0">
                        {t("Initial Welcome Message")}
                      </label>
                      <div className="button py-1 px-3" onClick={resetHandler}>
                        {t("RESET")}
                      </div>
                    </div>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      id="exampleForm.ControlTextarea1"
                      value={initialMsg}
                      onChange={(event) => {
                        setInitialMsg(event.target.value);
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      {t("Suggested Questions")}
                    </label>
                    <textarea
                      rows="3"
                      id="exampleForm.ControlTextarea1"
                      className="form-control"
                      spellcheck="false"
                      value={suggestedMsg}
                      onChange={(event) => {
                        setSuggestedMsg(event.target.value);
                        setSuggestedQuestion(event.target.value.split("\n"));
                      }}
                    ></textarea>
                    <div className="form-text">
                      {t("Enter each message in a new line")}
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      {t("Display name")}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      id="name"
                      value={displayName}
                      onChange={(event) => {
                        setDisplayName(event.target.value);
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      {t("Chat instructions")}
                    </label>
                    <textarea
                      rows="3"
                      id="chatInstructionText"
                      className="form-control"
                      value={chatInstructionText}
                      onChange={(event) => {
                        setChatInstructionText(event.target.value);
                      }}
                    ></textarea>
                    {/* <input 
                      type="text"
                      id="chatInstructionText"
                      className="form-control"
                      value={chatInstructionText}
                      onChange={(event) => {
                        setChatInstructionText(event.target.value);
                      }}
                    /> */}
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      {t("Chat bot image")}
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="formFile"
                      accept="image/*"
                      onChange={(event) => changeBotImage(event)}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label className="form-label">
                      {t("Company Logo")}
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      id="companyLogo"
                      accept="image/*"
                      onChange={(event) => changeCompanyLogo(event)}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="">
                      {t("Header Color")}
                    </label>
                    <div className="d-flex align-items-center justify-content-start gap-3">
                      <input
                        type="color"
                        className="form-control form-control-color"
                        id="headerColor"
                        value={headerColor}
                        title="Choose your color"
                        onChange={(event) => setHeaderColor(event.target.value)}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="">
                      {t("User Message Color")}
                    </label>
                    <div className="d-flex align-items-center justify-content-start gap-3">
                      <input
                        type="color"
                        className="form-control form-control-color"
                        id="exampleColorInput"
                        value={color}
                        title="Choose your color"
                        onChange={(event) => setColor(event.target.value)}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      {t("Align Chat Bubble Button")}
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      value={btnAlign}
                      onChange={(event) => setBtnAlign(event.target.value)}
                    >
                      <option selected>{t("Open this select menu")}</option>
                      <option value="Left">{t("Bottom Left")}</option>
                      <option value="Right">{t("Bottom Right")}</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      {t("Message Placeholder")}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="messageType"
                      id="messageType"
                      value={messageType}
                      onChange={(event) => {
                        setMessageType(event.target.value);
                      }}
                    />
                  </div>

                  <button
                    type="button"
                    className="userbutton"
                    value="SUBMIT"
                    onClick={(e) => updateBot(e)}
                  >
                    {loading ? <BtnLoader /> : t("Submit")}
                  </button>
                </form>
              </div>
            </Col>
            <Col lg={5}>
              <section className="chating_box">
                <Container>
                  <Row className="justify-content-center">
                    <Col md={12}>
                      <div className="chatingwrap">
                        <div className="chating_head" style={{ background: headerColor }}>
                          <div className="brand">
                            <span>{displayName}</span>
                          </div>
                          <div className="refresh">
                            <i className="fa-solid fa-close"></i>
                          </div>
                        </div>
                        <div className="chating_area">
                          <ul>
                            <li className="sender">
                              <div className="cont">
                                <span>{initialMsg}</span>
                              </div>
                            </li>
                            <li
                              className="repaly"
                              style={{ background: color }}
                            >
                              <div className="cont">
                                <span>
                                  {t("I will be happy to answer your questions.")}
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="sugbox">
                          {suggestedQuestion &&
                            suggestedQuestion.map((question) => {
                              return <span>{question}</span>;
                            })}
                        </div>
                        <div className="chating_foot">
                          <form action="">
                            <input
                              type="text"
                              className="form-control"
                              aria-label="message…"
                              placeholder={messageType}
                            />
                            <button
                              type="button"
                              className="button send_btn"
                              style={{ background: color }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-send" width="22" height="22" viewBox="0 0 24 24" stroke-width="1.5" stroke="#FFF" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="" />
                                <path d="M10 14l11 -11" />
                                <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
                              </svg>
                            </button>
                          </form>
                        </div>
                      </div>
                      <div className="chat_icon">
                        <span>{bubbleName}</span>
                        <div className="icon">
                          <img
                            src={
                              chatBotImage
                                ? chatBotImage
                                : "https://seekicon.com/free-icon-download/chat_7.svg"
                            }
                            alt=""
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </section>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatBotInterface;
